import ModalTextField from 'components/ModalTextField';
import { CalculateFieldNames } from 'utils/constants/fieldNames';
import { RequiredInfoSectionProps } from 'interfaces/components/dataEntryModal/RequiredInfoSection';
import {
  annualRevenueModalField,
  arrPerFteField,
  avgDealSizeField,
  currentArrField,
  fcfMarginField,
  grossMarginField,
  ruleOf40Field,
  totalHeadcountField,
  yoyArrGrowthField
} from 'utils/constants/fields';
import CompanyStatus from 'components/CompanyStatus';

const RequiredInfoSection = ({
  requiredInfoParentRef,
  requiredInfoRef,
  currentCompanyStatus,
  onCompanyStatusChange,
  currentARR,
  onCurrentArrChange,
  revenue,
  onRevenueChange,
  totalHeadcount,
  onTotalHeadcountChange,
  fcfMargin,
  onFcfMarginChange,
  grossMargin,
  onGrossMarginChange,
  yoyARR,
  onYoyARRChange,
  arrPerFTE,
  onArrPerFTEChange,
  ruleOf40,
  onRuleOf40Change,
  avgDealSize,
  onAvgDealSizeChange,
  handleCalculateBtnClick
}: RequiredInfoSectionProps) => {
  return (
    <div className='w-full' ref={requiredInfoParentRef}>
      <div
        className='w-full flex flex-col items-start gap-4 scroll-mt-3'
        ref={requiredInfoRef}
      >
        <p className='text-[24px] leading-[19.2px] font-light'>
          Required Information
        </p>
        <CompanyStatus
          currentCompanyStatus={currentCompanyStatus}
          onCompanyStatusChange={onCompanyStatusChange}
        />
        <div className='w-full grid grid-cols-2 gap-4 items-start'>
          <ModalTextField
            {...currentArrField}
            value={currentARR ? currentARR : ''}
            onChange={onCurrentArrChange}
          />
          <ModalTextField
            {...annualRevenueModalField}
            value={revenue ? revenue : ''}
            onChange={onRevenueChange}
          />
          <ModalTextField
            {...fcfMarginField}
            value={fcfMargin ? fcfMargin : ''}
            onChange={onFcfMarginChange}
            containerStyle='walkthrough-calculate'
          />
          <ModalTextField
            {...totalHeadcountField}
            tooltip='Please enter your total headcount including all full-time employees'
            value={totalHeadcount ? totalHeadcount : ''}
            onChange={onTotalHeadcountChange}
          />
          <ModalTextField
            {...grossMarginField}
            value={grossMargin ? grossMargin : ''}
            onChange={onGrossMarginChange}
          />
          <ModalTextField
            {...yoyArrGrowthField}
            value={yoyARR ? yoyARR : ''}
            onChange={onYoyARRChange}
          />
          <ModalTextField
            {...arrPerFteField}
            value={arrPerFTE ? arrPerFTE : ''}
            onChange={onArrPerFTEChange}
            onCalculateBtnClick={() =>
              handleCalculateBtnClick(CalculateFieldNames.ARR_PER_FTE)
            }
            showCalculateBtn
          />
          <ModalTextField
            {...ruleOf40Field}
            value={ruleOf40 ? ruleOf40 : ''}
            onChange={onRuleOf40Change}
            showCalculateBtn
            onCalculateBtnClick={() =>
              handleCalculateBtnClick(CalculateFieldNames.RULE_OF_40)
            }
          />
          <ModalTextField
            {...avgDealSizeField}
            value={avgDealSize ? avgDealSize : ''}
            onChange={onAvgDealSizeChange}
          />
        </div>
      </div>
    </div>
  );
};

export default RequiredInfoSection;
